import {observable, action} from 'mobx'
import {json} from "../../../utils/ajax";
import {runInAction} from "mobx/lib/mobx";
import {setStore} from "../../../utils/Utils";

class journalismStore {
    @observable notice  //通知及公告
    @observable current  //默认显示栏目
    @observable pagination
    @observable news  //保存新闻显示
    @observable fontSizeStyle  //新闻显示字体大小

    constructor() {
        this.loading = false
        this.notice = []
        this.current = 'notice'
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.news = {}
        this.fontSizeStyle='12px'
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }


    /***通知及公告 notice***/
    @action
    initNotices = async (key) => {
        this.loading = true
        let keys = key ? key : 'notice'
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/frontdesk`,{size:this.pagination.pageSize})
        runInAction(() => {
            this.notice = res ? res.content : []
            this.current = key ? key : 'notice'
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading=false
        })
    }

    /***保存当前新闻内容***/
    @action
    initNews = async (name, id) => {
        this.loading=true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/frontdesk`)
       let res1 = res && res.filter(item => item.id === id)
        runInAction(()=>{
            this.news=res1[0]
            this.loading=false
        })
    }

}

export default new journalismStore()



// WEBPACK FOOTER //
// ./src/project/dongfeng/Journalism/store.js